angular.module('app.formalizacao').factory('consultaPropostaFactory', function ($http, $q, errorService) {
    var _apiName = 'PropostaConsulta';

    function post(action, dto) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/' + action, dto);
    }

    var LAYOUTS_S3_REMESSA_FUNDO = [122, 123, 124, 125, 126, 127];
    var LAYOUT_REMESSA_FUNDO_S3_DIRETO = 115;

    function _downloadArquivoRemessaFundo(codigoRemessaFundo) {
        window.open('/download.aspx?type=REMFUNDO&code=' + codigoRemessaFundo);
    }

    function _downloadArquivoRemessaFundoS3(codigoRemessaFundo) {
        window.open('/download.aspx?type=REMFUNDOS3&code=' + codigoRemessaFundo);
    }

    function _gerarArquivoRemessaFundo(codigoRemessaFundo) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoRemessaFundo", "value": codigoRemessaFundo });
        return $http.post(appConfig.serviceBase + 'api/RemessaFundo/GerarArquivo', dto);
    }

    function _dispararDownloadArquivo(response) {
        var headers = response.headers();
        var filename = "";

        var disposition = headers["content-disposition"];
        if (disposition && disposition.indexOf('attachment') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, '');
            }
        }

        var blob = new Blob([response.data], { type: headers['content-type'] });
        var url = window.URL.createObjectURL(blob);

        var linkElement = document.createElement('a');
        linkElement.setAttribute('href', url);
        linkElement.setAttribute('download', filename);

        var clickEvent = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: false
        });
        linkElement.dispatchEvent(clickEvent);
    }

    var factory = {};

    factory.buscar = function (tipo, valor) {
        return post('Buscar', { Tipo: tipo, Valor: valor });
    };

    factory.geral = function (codigo) {
        return post('Geral', { id: codigo });
    };

    factory.tomador = function (codigo) {
        return post('Tomador', { id: codigo });
    };

    factory.cessao = function (codigo) {
        return post('Cessao', { id: codigo });
    };

    factory.desembolso = function (codigo) {
        return post('Desembolso', { id: codigo });
    };

    factory.parcelas = function (codigo) {
        return post('Parcelas', { id: codigo });
    };

    factory.fgts = function (codigo) {
        return post('Fgts', { id: codigo });
    };

    factory.documentos = function (codigo) {
        return post('Documentos', { id: codigo });
    };

    factory.comentarios = function (codigo) {
        return post('Comentarios', { id: codigo });
    };

    factory.reprocessarLastro = function (codigo) {
        return post('ReprocessarLastro', { id: codigo });
    };

    factory.baixarCnab = function (codigoRemessaFundo, tipoLayoutFundo) {
        if (tipoLayoutFundo === LAYOUT_REMESSA_FUNDO_S3_DIRETO) {
            _downloadArquivoRemessaFundoS3(codigoRemessaFundo);
            return $q.resolve();
        }

        return _gerarArquivoRemessaFundo(codigoRemessaFundo).then(function (response) {
            if (response.data && response.data.HasError) {
                errorService.processError(response);
                return $q.reject(response);
            }

            if (LAYOUTS_S3_REMESSA_FUNDO.indexOf(tipoLayoutFundo) !== -1) {
                _downloadArquivoRemessaFundoS3(codigoRemessaFundo);
            } else {
                _downloadArquivoRemessaFundo(codigoRemessaFundo);
            }
        }, function (response) {
            errorService.processError(response);
            throw response;
        });
    };

    factory.baixarDocumento = function (origem, codigo) {
        window.open('/download.aspx?type=PD&code=' + codigo);
    };

    factory.baixarDocumentoProposta = function (codigo, tipoDocumento) {
        if (tipoDocumento === 90 || tipoDocumento === 91 || tipoDocumento === 92) {
            window.open('/download.aspx?type=FGTS&code=' + codigo);
        } else {
            window.open('/download.aspx?type=PROPD&code=' + codigo);
        }
    };

    factory.baixarTermoEndosso = function (codigoDocumentoTermoEndosso) {
        window.open('/download.aspx?type=PROPD&code=' + codigoDocumentoTermoEndosso);
    };

    factory.baixarTermoCessao = function (codigoCessao, codigoCessaoDocumento) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "Codigo", "value": codigoCessao });
        dto.parms.push({ "name": "CodigoCessaoDocumento", "value": codigoCessaoDocumento });

        return $http.post(appConfig.serviceBase + 'api/CessaoHub/ObterTermoCessao', dto, {
            responseType: 'arraybuffer'
        }).then(_dispararDownloadArquivo, function (response) {
            errorService.processError(response);
            throw response;
        });
    };

    return factory;
});
